module.exports = __webpack_public_path__ + "static/media/Subscription_Organization.badc6d56.png";